module.exports = __webpack_public_path__ + "img/en_US.4d1db99.jpg";